/* eslint-disable @typescript-eslint/naming-convention */
export const partnerContentKeyMap = {
    'income.input.yearlyIncome': 'income.input.yearlyIncome',
    'income.input.yearlyIncome.helpText': 'income.input.yearlyIncome.helpText',
    'income.input.monthlyIncome.description': 'income.partner.input.monthly-income.description',
    'income.input.monthlyIncome.label': 'income.input.monthly-income.label',
    'income.input.calculateYearlyIncome': 'income.partner.input.calculate-yearly-income',
    'income.input.optionVacationPayment': 'income.partner.input.option-vacation-payment',
    'income.input.optionThirteenthMonthPayment': 'income.partner.input.option-thirteenth-month-payment',
    'income.input.optionBonusPayment': 'income.partner.input.option-bonus-payment',
    'income.input.entrepreneurIncome.label': 'income.partner.input.entrepreneur-income.label',
    'income.input.taxableProfit.label': 'income.partner.input.taxable-profit.label'
};

/* eslint-disable @typescript-eslint/naming-convention */
export const mainContentKeyMap = {
    'income.input.yearlyIncome': 'income.input.yearlyIncome',
    'income.input.yearlyIncome.helpText': 'income.input.yearlyIncome.helpText',
    'income.input.monthlyIncome.description': 'income.input.monthly-income.description',
    'income.input.monthlyIncome.label': 'income.input.monthly-income.label'
};

export const todayDate: Date = normalizeToUTCMidnight(new Date());

export function normalizeToUTCMidnight(date: Date): Date {
    if (!date || !(date instanceof Date)) {
        return null;
    }

    const copyDate = new Date(date);
    copyDate.setUTCHours(0, 0, 0, 0);

    return copyDate;
}

export function getMaxDate(): Date {
    const defaultDate = new Date();
    defaultDate.setUTCFullYear(todayDate.getUTCFullYear() - 18, todayDate.getMonth(), todayDate.getDate());

    return normalizeToUTCMidnight(defaultDate);
}

export function getMinDate(): Date {
    const defaultDate = new Date();
    defaultDate.setUTCFullYear(todayDate.getUTCFullYear() - 100, todayDate.getMonth(), todayDate.getDate());

    return normalizeToUTCMidnight(defaultDate);
}
